import React from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { childrenPropType } from 'tss-core-lib-common';

import './pageSlideAnimations.css';

export var pageAnimationTimeout = 200;
export var pageAnimationClassNames = 'page-animation';

export var DirectionalTransitionGroup = function DirectionalTransitionGroup(_ref) {
  var reverse = _ref.reverse,
      children = _ref.children;
  return React.createElement(
    'div',
    { className: reverse ? 'page-animation page-animation--reverse' : 'page-animation' },
    React.createElement(
      TransitionGroup,
      null,
      children
    )
  );
};

DirectionalTransitionGroup.propTypes = {
  reverse: PropTypes.bool,
  children: childrenPropType.isRequired
};

DirectionalTransitionGroup.defaultProps = {
  reverse: false
};